<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  export let value: string;
  export let placeholder = '';
  export let multiline = false;
  let className = '';
  export { className as class };

  const dispatch = createEventDispatcher<{
    change: string;
  }>();

  let editing = false;
  let editValue = value;
  let inputElement: HTMLInputElement | HTMLTextAreaElement;

  function startEditing() {
    editValue = value;
    editing = true;
    // Focus after DOM update
    setTimeout(() => inputElement?.focus(), 0);
  }

  function handleBlur() {
    if (editValue !== value) {
      dispatch('change', editValue);
    }
    editing = false;
  }

  function handleKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter' && !multiline) {
      event.preventDefault();
      inputElement?.blur();
    }
    if (event.key === 'Escape') {
      editValue = value;
      editing = false;
    }
  }
</script>

{#if editing}
  {#if multiline}
    <textarea
      bind:this={inputElement}
      bind:value={editValue}
      {placeholder}
      class="w-full bg-white border border-blue-500 rounded px-2 py-1 outline-none resize-none {className}"
      rows="3"
      on:blur={handleBlur}
      on:keydown={handleKeydown}
    />
  {:else}
    <input
      bind:this={inputElement}
      type="text"
      bind:value={editValue}
      {placeholder}
      class="w-full bg-white border border-blue-500 rounded px-2 py-1 outline-none {className}"
      on:blur={handleBlur}
      on:keydown={handleKeydown}
    />
  {/if}
{:else}
  <button
    type="button"
    class="w-full text-left editable {className}"
    on:click={startEditing}
  >
    {#if value}
      <span class="whitespace-pre-wrap">{value}</span>
    {:else}
      <span class="text-gray-400">{placeholder}</span>
    {/if}
  </button>
{/if}
